import { Directive, Input, ElementRef, Renderer2, OnInit, HostListener } from '@angular/core';

@Directive({
  selector: '[unhAddClassOnClick]'
})
export class AddClassOnClickDirective {
  @Input() defaultClass = '';
  @Input() classToAdd = '';

  constructor(private elRef: ElementRef, private r2: Renderer2) {}

  @HostListener('click')
  onClick() {
    if (this.classToAdd != null && this.classToAdd !== '') {
      // SHAMEEEEE!!!!
      // Should this have a parent controlling?
      const allSimilars = document.querySelectorAll('.' + this.defaultClass);
      allSimilars.forEach((el) => {
        this.r2.removeClass(el, this.classToAdd);
      });
      /// END SHAME

      this.r2.addClass(this.elRef.nativeElement, this.classToAdd);
    }
  }
}
